import { __decorate } from "tslib";
import { Router } from '@angular/router';
import { provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { FeatureFunctionalityModelTableColumn } from '@core/shared/model';
import * as i0 from "@angular/core";
let UsersAdminFeature = /*#__PURE__*/(() => {
  let UsersAdminFeature = class UsersAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/users/frontend-admin","featureId":"common-users"};
    }
    getFeatureFunctionality(functionality) {
      const enableReferrers = this.config.get('users.enableReferrers', true);
      const enableCompanies = this.config.get('users.enableCompanies', false);
      const adminToolbarItems = [{
        label: 'Alle Benutzer',
        routerLink: 'users/all'
      }];
      if (enableReferrers) adminToolbarItems.push({
        label: 'Referrer',
        routerLink: 'users/referrers'
      });
      if (enableCompanies) adminToolbarItems.unshift({
        label: 'Unternehmen',
        routerLink: 'users/companies'
      }, {
        label: 'Demos',
        routerLink: 'users/company-demos'
      });
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Benutzer',
          routerLink: 'users',
          icon: 'user',
          declareGroup: 'user',
          items: adminToolbarItems,
          priority: 10
        }, {
          displayInGroup: 'statistics',
          label: 'Benutzer',
          routerLink: 'statistics/users',
          icon: 'user-plus'
        }, {
          displayInGroup: 'statistics',
          label: 'Benutzer-Aktivität',
          routerLink: 'statistics/users/activity',
          icon: 'user-clock'
        }],
        adminTopMenu: [{
          label: 'Profil',
          routerLink: '/user/profile',
          icon: 'user',
          priority: 1
        }, {
          label: 'Logout',
          routerLink: '/user/logout',
          icon: 'lock',
          priority: -1
        }]
      });
      if (enableCompanies) {
        functionality.defineModelColumns([new FeatureFunctionalityModelTableColumn('UserItem', ['crud'], {
          field: 'company',
          header: 'Unternehmen',
          width: '280px',
          render: user => {
            if (user.company) {
              let out = user.company.name;
              if (user.company.managers) out += '<br>' + user.company.managers[0].name;
              return '<small>' + out + '</small>';
            }
            return '-';
          }
        })]);
      }
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        label: 'Skillset-Analyse',
        icon: "magnifying-glass-location",
        action: item => {
          const link = ['users', 'skillset-analysis', item.id];
          this.injector.get(Router).navigate(link);
        }
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUsersAdminFeature_BaseFactory;
        return function UsersAdminFeature_Factory(__ngFactoryType__) {
          return (ɵUsersAdminFeature_BaseFactory || (ɵUsersAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(UsersAdminFeature)))(__ngFactoryType__ || UsersAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: UsersAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'user',
          loadChildren: () => import('@common/users/frontend/users-frontend.module').then(m => m.UsersFrontendModule)
        }, {
          path: 'users',
          loadChildren: () => import('./users-admin.module').then(m => m.UsersAdminModule)
        }
        // {path: 'statistics', redirectTo:'statistics/users' },
        ]), provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'users',
          loadChildren: () => import('./statistics/users-stats.module').then(m => m.UsersStatsModule)
        }])]
      });
    }
  };
  UsersAdminFeature = __decorate([ClassName("UsersAdminFeature")], UsersAdminFeature);
  return UsersAdminFeature;
})();
export { UsersAdminFeature };